<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>Science Department</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>Departments</li>
                    <li>Department of Science</li>
                </ul>
            </div>
        </div>
    </div>
    <!--End Page Banner-->

    <!--Start Courses Details Area-->
    <div class="courses-details-area pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="courses-details">
                        <div class="courses-card">
                            <h2>Degree Offered</h2>
                        </div>
                        <div class="description">
                            <div class="container p-0">
                                <nav>
                                    <div class="nav nav-tabs d-flex justify-content-between" id="nav-tab"
                                        role="tablist">
                                        <button style="width: 50%;" class="nav-link active" id="nav-overview-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-overview" type="button" role="tab"
                                            aria-controls="nav-overview" aria-selected="true">Bachelor of Science
                                            (B.Sc.)</button>

                                        <button style="width: 50%;" class="nav-link" id="nav-curriculum-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-curriculum" type="button"
                                            role="tab" aria-controls="nav-curriculum" aria-selected="false">Master of
                                            Science
                                            (M.Sc.)</button>
                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-overview" role="tabpanel"
                                        aria-labelledby="nav-overview-tab">
                                        <div class="overview">
                                            <div class="learn">
                                                <h3>Overview</h3>
                                                <p>The Bachelor of Science (B.Sc.) Pass Course is a three-year
                                                    undergraduate program that provides foundational knowledge in core
                                                    science subjects. It focuses on practical and theoretical aspects of
                                                    scientific study, preparing students for diverse careers and further
                                                    education in science and technology.
                                                    <br />
                                                    <strong>Subject Includes : </strong> Physics, Chemistry,
                                                    Mathematics, Botany, Zoology.
                                                </p>
                                            </div>
                                            <div class="learn">
                                                <h3>What you will learn?</h3>
                                                <p>The Bachelor of Science (B.Sc.) is a 3-year undergraduate degree
                                                    focused on developing a strong foundation in scientific knowledge,
                                                    analytical thinking, and research skills. It offers specialization
                                                    in subjects like Physics, Chemistry, Biology, Mathematics etc.</p>
                                                <ul>
                                                    <li>Core concepts of your chosen science discipline (e.g., Physics,
                                                        Chemistry, etc.)</li>
                                                    <li>Scientific methods, experimentation, and data analysis.</li>
                                                    <li>Problem-solving and critical thinking skills.</li>
                                                    <li>Use of scientific tools and technologies.</li>
                                                    <li>Research methodology and academic writing.</li>
                                                    <li>Optional interdisciplinary and elective subjects.</li>
                                                </ul>
                                                
                                            </div>
                                            <div class="overview-box">
                                                <h4>Learning Outcome</h4>
                                                <ul>
                                                    <li>Demonstrate in-depth knowledge of their specialization.</li>
                                                    <li>Apply scientific techniques to solve real-world problems.</li>
                                                    <li>Communicate scientific ideas effectively.</li>
                                                    <li>Conduct independent or group-based scientific research.</li>
                                                    <li>Pursue higher studies (M.Sc., MBA, etc.) or prepare for
                                                        competitive exams.</li>
                                                </ul>
                                            </div>
                                            <div class="overview-box">
                                                <h4>Career Opportunities</h4>
                                                <ul>
                                                    <li> Research Assistant in scientific labs and institutions.</li>
                                                    <li> Laboratory Technician in medical or industrial labs.
                                                    </li>
                                                    <li>Data Analyst in various industries.
                                                    </li>
                                                    <li>Teaching at school or junior college level.</li>
                                                    <li> Environmental Officer, Clinical Research Associate,
                                                        Pharmaceutical Sales Representative.
                                                    </li>
                                                    <li>Higher Education: M.Sc., MCA, MBA, or professional
                                                        certifications.
                                                    </li>
                                                    <li>Government Jobs through UPSC, SSC, State PSCs, etc.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="nav-curriculum" role="tabpanel"
                                        aria-labelledby="nav-curriculum-tab">
                                        <div class="curriculum">
                                            <div class="overview">
                                                <div class="learn">
                                                    <h3>Overview</h3>
                                                    <p>TThe Master of Science (M.Sc.) is a two-year postgraduate program
                                                        offering in-depth knowledge in a specialized science subject. It
                                                        focuses on advanced scientific theory, research, and practical
                                                        applications.
                                                        <br />
                                                        <strong>Subject includes: </strong> Physics, Chemistry
                                                        Mathematics, Botany
                                                    </p>
                                                </div>
                                                <div class="learn">
                                                    <h3>What you will learn?</h3>
                                                    <p>A Master of Science (M.Sc.) is a two year postgraduate academic
                                                        degree focused on scientific and mathematical subjects. It
                                                        offers in-depth theoretical and practical knowledge, research
                                                        opportunities, and skill development in a specialized field.</p>
                                                    <ul>
                                                        <li>Advanced concepts in your chosen scientific discipline. .
                                                        </li>
                                                        <li>Research methodologies and data analysis.</li>
                                                        <li>Use of scientific tools and laboratory techniques.</li>
                                                        <li>Application of theoretical knowledge to real-world problems.
                                                        </li>
                                                        <li>Critical thinking and scientific communication.</li>
                                                        <li>Interdisciplinary approaches and innovations in science.
                                                        </li>
                                                    </ul>

                                                </div>
                                                <div class="overview-box">
                                                    <h4>Learning Outcome</h4>
                                                    <ul>
                                                        <li>Demonstrate expertise in their specialized subject area.
                                                        </li>
                                                        <li>Design and conduct experiments and analyze scientific data
                                                            .</li>
                                                        <li>Solve complex scientific problems using analytical methods.
                                                        </li>
                                                        <li>Communicate scientific findings effectively.</li>
                                                        <li>Pursue research, teaching, or advanced academic study.</li>
                                                        <li>Work independently or collaboratively in scientific
                                                            settings.
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="overview-box">
                                                    <h4>Career Opportunities</h4>
                                                    <ul>
                                                        <li>Research Scientist (in public/private R&D sectors)
                                                        </li>
                                                        <li>Lecturer/Assistant Professor in colleges and universities
                                                        </li>
                                                        <li>Laboratory Manager or Technician
                                                        </li>
                                                        <li>Ph.D. Researcher or Academic Scholar
                                                        </li>
                                                        <li> Science Writer or Consultant
                                                        </li>
                                                        <li>Roles in Government Agencies, NGOs, or International
                                                            Organizations
                                                        </li>
                                                        <li>Industry roles in pharmaceuticals, IT, data science,
                                                            environmental science, and more (depending on the
                                                            specialization)
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4" style="display: none;">
                    <div class="related-download">
                        <h3>Related Links</h3>
                        <ul>
                            <li><a href="fees.html"><i class="flaticon-writing-tool"></i>Fees Structure</a></li>
                            <li><a href="eligibility.html"><i class="flaticon-writing-tool"></i>Eligiblity
                                    Criteria</a>
                            </li>
                            <li><a href="../about/campus.html"><i class="flaticon-writing-tool"></i>Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--End Courses Details Area-->

    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link to="/syllabus" class="default-btn btn">Syllabus<i
                            class="flaticon-next"></i></router-link>
                    <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ScienceDeptView"
};
</script>
